import React from "react";
import "./ui.css";

// One page-header shape for every role: eyebrow/title/description on the
// left, primary/secondary/refresh actions on the right -- desktop aligns
// them on one row, mobile stacks title/description above actions instead
// of forcing everything onto one cramped line.
export default function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="ui-page-header">
      <div>
        {eyebrow && <div className="ui-page-header-eyebrow">{eyebrow}</div>}
        <h1 className="ui-page-header-title">{title}</h1>
        {description && <p className="ui-page-header-desc">{description}</p>}
      </div>
      {actions && <div className="ui-page-header-actions">{actions}</div>}
    </div>
  );
}
